import { ApolloProvider } from '@apollo/client'

import { useEffect, useState } from 'react'
import { BrowserRouter } from 'react-router-dom'

import { FloraProvider } from '@grupoboticario/flora-react'

import { HeaderProvider } from '@/context/header'
import { client } from '@/plugins/apollo/client'
import { AppRouter } from '@/router'
import { theme } from '@/utils/themes/theme'
import { businessUnitTheme } from '@/utils/themes/themes'

const AppContent = () => {
  const [themeProvider, setThemeProvider] = useState<string | null>(null)

  useEffect(() => {
    setThemeProvider(theme(globalThis?.location?.hostname))
  }, [])

  if (themeProvider === null) return null

  return (
    <FloraProvider theme={businessUnitTheme[themeProvider] || ''}>
      <ApolloProvider client={client}>
        <HeaderProvider>
          <AppRouter />
        </HeaderProvider>
      </ApolloProvider>
    </FloraProvider>
  )
}

const App = () => {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  )
}

export { App }
